const env = import.meta.env;

const api = (env.VITE_API_BASE_URL || "").replace(/\/+$/, "");
const base = env.VITE_ROUTER_BASENAME || env.BASE_URL || "/";
const defaultName = env.VITE_BRAND_APP_NAME || env.VITE_PWA_NAME || "Digicall-Alert";
const defaultDescription =
  env.VITE_PWA_DESCRIPTION || "Digicall-Alert Progressive Web App";
const defaultTheme = env.VITE_PWA_THEME_COLOR || "#1976d2";
const defaultFavicon = env.VITE_BRAND_FAVICON || "/favicon.ico";
const envBrand = env.VITE_BRAND_CODE || env.VITE_BRAND_ID || "digicall";

const ROUTE_SEGMENTS = new Set([
  "",
  "login",
  "register",
  "dashboard",
  "home",
  "forgot",
  "reset",
  "profile",
  "settings",
  "about",
  "help",
]);

function normalizeBasePath(raw: string | undefined) {
  const trimmed = (raw || "/").trim();
  if (trimmed === "/") return "";
  return (trimmed.startsWith("/") ? trimmed : `/${trimmed}`).replace(/\/+$/, "");
}

function deriveBrandCode(basePath: string) {
  const path = location.pathname.startsWith(basePath)
    ? location.pathname.slice(basePath.length)
    : location.pathname;
  const segment = (path.split("/").filter(Boolean)[0] || "").trim().toLowerCase();
  if (!segment || ROUTE_SEGMENTS.has(segment)) return envBrand;
  return segment.replace(/_(current|preprod|prod|local)$/i, "") || envBrand;
}

document.title = defaultName;
document.getElementById("app-description")?.setAttribute("content", defaultDescription);
document.getElementById("theme-color")?.setAttribute("content", defaultTheme);
document.getElementById("app-favicon")?.setAttribute("href", defaultFavicon);

const basePath = normalizeBasePath(base);
const brandCode = deriveBrandCode(basePath);

if (!api) {
  console.warn("VITE_API_BASE_URL is not set; manifest will not be loaded.");
} else {
  const params = new URLSearchParams();
  params.set("origin", location.origin);
  params.set("bp", basePath || "/");

  const manifestHref = `${api}/branding/manifest/${encodeURIComponent(
    brandCode,
  )}.webmanifest?${params}`;

  const link = document.getElementById("app-manifest");
  link?.setAttribute("href", manifestHref);
  link?.setAttribute("type", "application/manifest+json");
  link?.setAttribute("rel", "manifest");
}
